import { ROUTE_COLORS, FUEL_ROUTE_THRESHOLDS } from '../config/routeStatus.js';

// Pure route-line styling (#53-T8): no Leaflet, EventBus or GameState.
// Severity: 0 fine, 1 warning, 2 critical.

// Read at call time so config edits apply without a reload.
const SEVERITY_KEY = ['ok', 'warn', 'critical'];
const colorFor = (sev) => ROUTE_COLORS[SEVERITY_KEY[sev]];
const SEVERITY_WORD = ['ok', 'warn', 'critical'];

/** 0/1/2 from the ship's fuel ratio (boundaries inclusive, as before). */
export function fuelSeverity(ship) {
  const ratio = ship && ship.maxFuel > 0 ? ship.fuel / ship.maxFuel : 1;
  if (ratio <= FUEL_ROUTE_THRESHOLDS.critical) return 2;
  if (ratio <= FUEL_ROUTE_THRESHOLDS.warn) return 1;
  return 0;
}

/** 0 onTime/none/unknown, 1 behind, 2 late. Accepts a status string or a schedule result. */
export function scheduleSeverity(schedule) {
  const status = typeof schedule === 'string' ? schedule : schedule?.status;
  if (status === 'late') return 2;
  if (status === 'behind') return 1;
  return 0;
}

const FUEL_CAUSE = ['', 'Fuel low', 'Fuel critical'];
const SCHEDULE_CAUSE = { behind: 'Running behind schedule', late: 'Will miss contract deadline' };

/**
 * Style for an active (solid) line: worse of fuel and schedule severity.
 * @returns {{ color:string, severity:number, cause:string, causes:string[] }}
 */
export function getActiveRouteStyle(ship, schedule = null) {
  const fuel = fuelSeverity(ship);
  const sched = scheduleSeverity(schedule);
  const severity = Math.max(fuel, sched);
  const causes = [];
  if (fuel > 0) causes.push(FUEL_CAUSE[fuel]);
  if (sched > 0) causes.push(SCHEDULE_CAUSE[schedule?.status || schedule]);
  return {
    color: colorFor(severity),
    severity,
    level: SEVERITY_WORD[severity],
    cause: causes.join(' + '),
    causes
  };
}

/** Style for a held (dashed) line: schedule only, grey when none/unknown. */
export function getPlannedRouteStyle(schedule = null) {
  const sev = scheduleSeverity(schedule);
  const status = typeof schedule === 'string' ? schedule : schedule?.status;
  if (sev === 0 && status !== 'onTime') {
    return { color: ROUTE_COLORS.planned, severity: 0, level: 'planned', cause: '', causes: [] };
  }
  const cause = sev > 0 ? SCHEDULE_CAUSE[status] : '';
  return {
    color: colorFor(sev),
    severity: sev,
    level: SEVERITY_WORD[sev],
    cause,
    causes: cause ? [cause] : []
  };
}
